import {
  fork,
  put,
  all,
  call,
  takeLatest,
} from 'redux-saga/effects'
import normalize from 'jsonapi-normalizer'
import {
  getRequest,
  postRequest,
} from 'helpers/RequestUtil'

import T from 'i18n-react'
import { success, error } from 'containers/App/Notification/actions'
import {
  fetchSkusStart,
  fetchSkusSucess,
  fetchSkusError,
  fetchSegmentLineStart,
  fetchSegmentLineSuccess,
  fetchSegmentLineError,
  postFormStart,
  postFormSuccess,
  postFormError,
  updateSegmentList,
  updateLineList,
  updateProductSkus,
} from './actions'
import {
  FETCH_PRODUCT_SKUS,
  POST_FORM,
  FETCH_SEGMENT_LINE,
} from './constants'
import {
  redirect
} from 'containers/Redirect/actions'


function* fetchSegmentLines() {
  try {
    yield put(fetchSegmentLineStart())
    const data = yield call(getRequest, '/api/fulcrum/admin/segment_and_line')
    yield put(fetchSegmentLineSuccess())
    return data
  } catch(error) {
    yield put(fetchSegmentLineError(error))
  }
}

function* fetchProductSkus(segment, line) {
  try {
    yield put(fetchSkusStart())
    const url = `api/fulcrum/product/product_skus?segment=${segment}&line=${line}`
    const data = yield call(getRequest, url)
    yield put(updateProductSkus(data.products))
    yield put(fetchSkusSucess())
    return data
  } catch(error) {
    yield put(fetchSkusError(error))
  }
}

function* fetchProductID(productSkuName) {
  try {
    const data = yield call(getRequest, `/api/fulcrum/product/lists?filter[search]=${productSkuName}`)
    const { result } = normalize(data)
    if (result.hasOwnProperty('lists')) return result['lists'][0]
  } catch(error) {
    yield put(fetchSkusError(error))
  }
}

function* handleFetchSegmentLine() {
  let data = yield call(fetchSegmentLines)
  let segments = data.segments
  let lines = data.lines
  yield put(updateSegmentList(segments))
  yield put(updateLineList(lines))
}

function* handleFetchProductSkus(action) {
  const { segment, line } = action
  yield call(fetchProductSkus, segment, line)
}

function* handleFormSubmit(action) {
  const { productDetails } = action
  try {
    yield put(postFormStart())
    // start product creation task on server
    const request = postRequest('add_sku', { productDetails })
    yield call(request, '/api/fulcrum/product/add_sku')
    // fetch productId of newly added product
    const productId = yield call(fetchProductID, productDetails.sku)
    yield put(postFormSuccess())
    yield put(success(T.translate('pages.admin.products.notification.create_success')))
    yield put(redirect(`/product/${productId}/view`))

  } catch(e) {
    console.log(e)
    yield put(postFormError(e))
    yield put(error(T.translate('pages.admin.products.notification.create_error')))
  }
}

function* watchFetchProductSkus() {
  yield takeLatest(FETCH_PRODUCT_SKUS, handleFetchProductSkus)
}

function* watchFetchSegmentLine() {
  yield takeLatest(FETCH_SEGMENT_LINE, handleFetchSegmentLine)
}  

function* watchSubmitForm() {
  yield takeLatest(POST_FORM, handleFormSubmit)
} 

function* ProductSagas() {
  yield all([
    fork(watchFetchProductSkus),
    fork(watchFetchSegmentLine),
    fork(watchSubmitForm),
  ])
}

export default ProductSagas